export const MOBILE_DETECTION_REGEXP = /Android|iPhone|iPad|BlackBerry|Windows Phone|Mobi/i

export enum DeviceSources {
  browser_mobile = 'browser_mobile',
  browser_computer = 'browser_computer'
}
